  <template>
  <div id="jigou_wrap">
    <headers/>
    <!-- <div id="jigou_wrap_new_uesr">学校注册</div> -->
    <div id="login_wrap_denglu">
      <div class="login_wrap_denglu_top">学校/教师注册</div>
      <router-link to="/regist" class="yanzhengma_enter">新用户注册></router-link>
    </div>
    <div id="jigou_form">
      <div class="jigou_form_wrap">
        <div class="jigou_form_wrap_tip">手机号码</div>
        <div class="jigou_form_form_number">
          <div class="jigou_form_form_number_left">
            <el-select v-model="value" placeholder="" class="jigou_wrap_form_number_left_se" filterable="">
              <el-option v-for="item in cities" :key="item.label" :label="item.value" :value="item.value">
                <span style="float: left">{{ item.label }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
              </el-option>
            </el-select>
          </div>
          <div class="jigou_for_number_right">
            <el-input v-model="input_content_jigou" placeholder="请输入手机号码" class="jigou_for_form_number_right_int" :class="{'colorerro':colorerro}"></el-input>
          </div>
        </div>
        <div class="number_erro" :class="{'colordisplays':errodisplay}">
          <div class="number_erro_content">{{numbererro}}</div>
        </div>
        <div class="yanzheng_code">验证码</div>
        <div class="yanzhengma_bor">
          <div class="yanzhengma_bor_left_infor" :class="{'colordisplays_two_y':errodisplay_two_y}">
            <el-input v-model="input_yanzhengma" placeholder="请输入验证码"></el-input>
          </div>
          <div class="yanzhengma_bor_btn" @click="getCode">
            <el-button class="impro_btn" :class="{'iscursor':iscursor}">获取验证码</el-button>
          </div>
        </div>
        <div class="yanzhengma_erro">
          <div :class="{'yanzheng_test':yanzheng_test}" class="yanzheng_cuowu">{{yanzhengma_con}}</div>
          <div class="yanzheng_time_lodaing" :class="{'yanzheng_loding':yanzheng_loding}">{{time_loging}}秒后可发送</div>
        </div>
        <!-- <div class="pinpai_content">品牌名称(非必填)</div>
        <div class="jigou_mingcheng_text">
          <el-input v-model="jigou_show" placeholder="请输入品牌名称" class="jigou_mingcheng_text_in"></el-input>
        </div> -->
        <!-- <div class="jigou_mingcheng_erro">
          <div class="jigou_mingcheng_erro_text" :class="{'yanzheng_jigou':yanzheng_test_jigou}">{{jigou_mingcheng_erro}}</div>
        </div> -->
        <div class="pinpai_content_gongsi">学校名称</div>
        <div class="jigou_mingcheng_text_checked">
          <el-input v-model="jigou_show_check" placeholder="请输入学校名称" class="jigou_mingcheng_text_in" :class="{'colorerro_one':colorerro_one}"></el-input>
        </div>
        <div class="qiyeone_erro" :class="{'colordisplays_two':errodisplay_two}">
          <div class="number_erro_content">{{qiyeone_erro_two}}</div>
        </div>
        <div class="pinpai_content_adress">所在地址</div>
        <div class="pinpai_content_adress_content">
          <el-select v-model="city_view" placeholder="请选择国家" class="country_select" @change="country_change" :class="{'colorerro_three':colorerro_three}">
            <el-option v-for="item in  arrcitydata" :key="item.value" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
          <el-select v-model="chengshiview" placeholder="请选择省/直辖市" class="country_select" v-show="see_province" @change="city_end" :class="{'colorerro_four':colorerro_four}">
            <el-option v-for="item in  arrcitydatas" :key="item.value" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
          <el-select v-model="chengshiview_surplus" placeholder="请选择城市" class="country_select" v-show="see_province_surplus" :class="{'colorerro_six':colorerro_six}">
            <el-option v-for="item in  arrcitydatas_surplus" :key="item.value" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
          <div class="qiyeone_erros" :class="{'colordisplays_three':errodisplay_three}">
            <div class="number_erro_content">{{qiyeone_erro_three}}</div>
          </div>
        </div>
        <div class="pinpai_leimu">主营类目</div>
        <div class="pinpai_leimu_content">
          <el-select v-model="pinpai_leimu_content" placeholder="请选择" :class="{'colorerro_seven':colorerro_seven}">
            <el-option v-for="item in pinpai_leimu_data" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <!-- <div class="pinpai_name">负责人姓名</div>
        <div class="pinpai_name_input">
          <el-input v-model="pinpai_name" placeholder="请输入负责人姓名" :class="{'colorerro_eight':colorerro_eight}"></el-input>
        </div>
        <div class="qiyeone_erro" :class="{'colorerro_nine':colorerro_nine}">
          <div class="number_erro_content">{{fuze_people}}</div>
        </div> -->
        <!-- <div class="pinpai_number">负责人电话</div>
        <div class="pinpai_name_input_number">
          <el-input v-model="pinpai_name_number" placeholder="请输入负责人电话" :class="{'colorerro_ten':colorerro_ten}"></el-input>
        </div>
        <div class="qiyeone_erro" :class="{'colorerro_ele':colorerro_ele}">
          <div class="number_erro_content">{{fuze_number}}</div>
        </div> -->
        <!-- <div class="pinpai_email">邮箱</div>
        <div class="pinpai_name_input_emali">
          <el-input v-model="pinpai_name_emali" placeholder="请输入邮箱" :class="{'colorerro_email':colorerro_email}"></el-input>
        </div>
        <div class="qiyeone_erro" :class="{'colorerro_email_erro':colorerro_email_erro}">
          <div class="number_erro_content">{{email_erro}}</div>
        </div> -->
        <div class="pinpai_name_password">密码</div>
        <div class="pinpai_name_input_passwordl">
          <el-input placeholder="请输入密码" v-model="pinpai_name_password" show-password :class="{'colorerro_one_pass':colorerro_one_pass}"></el-input>
        </div>
        <div class="qiyeone_erro" :class="{'colorerro_pass_erro':colorerro_pass_erro}">
          <div class="number_erro_content">{{pass_erro}}</div>
        </div>
        <div class="pinpai_name_password">确认密码</div>
        <div class="pinpai_name_input_passwordl">
          <el-input placeholder="请确认密码" v-model="pinpai_name_password_affirm" show-password :class="{'colorerro_one_affar':colorerro_one_affar}"></el-input>
        </div>
        <div class="qiyeone_erro" :class="{'colorerro_erro_affar':colorerro_erro_affar}">
          <div class="number_erro_content">{{affar_erro}}</div>
        </div>
        <div class="zhuce_wrap_form_submit" @click="sub_form_data()">
          <el-button class="zhuce_wrap_form_submit_btn" :class="{'zhuce_sub':zhucesub}">注册</el-button>
        </div>
        <div class="agree_tiaoyue">
          <div class="agree_tiaoyue_btn" @click="form_subit">
            <el-checkbox v-model="checkeds"></el-checkbox>
          </div>
          <div class="agree_tiaoyue_text">
            我已阅读并同意"
            <a href="#" class="fuwu_xieyi">《软件许可及服务协议》</a>和
            <a href="#" class="yinsi_xieyi">隐私政策</a>
          </div>
        </div>
        <social/>
      </div>
    </div>
    <footers/>
  </div>
</template>
<script>
import headers from "./header.vue";
import social from "./social.vue";
import Net_Work from "../apis/network.js";
import Address from "../apis/address.js";
import _ from "lodash";
import axios from "axios";
import footers from "./footers.vue";
import Qs from "qs";
axios.defaults.baseURL = Net_Work.publicApi;
axios.defaults.headers.post["Content-Type"] = Net_Work.publicPostset;
export default {
  name: "jigou",
  components: { headers, social, footers },
  data() {
    return {
      see_province: false,
      pass_erro: "长度8-16位，必须包含大小写字母和数字",
      colorerro_ten: false,
      colorerro_one_pass: false,
      affar_erro: "两次输入密码不一致",
      affirm_password: "",
      colorerro_erro_affar: true,
      colorerro_email_erro: true,
      colorerro_pass_erro: true,
      colorerro_seven: false,
      errodisplay_two_y: false,
      colorerro_eight: false,
      email_erro: "邮箱格式错误",
      colorerro_one_affar: false,
      colorerro_ele: true,
      colorerro_nine: true,
      fuze_number: "必须是数字,不能超过11个字符",
      checkeds: "",
      colorerro_email: false,
      zhucesub: false,
      pinpai_name_emali: "",
      time_loging: 60,
      pinpai_name_password_affirm: "",
      iscursor: false /*验证码是否可以点击关键变量*/,
      colorerro: false,
      pinpai_name: "",
      errodisplay: true /*添加errodisplay_new*/,
      pinpai_name_number: "",
      pinpai_name_password: "",
      yanzheng_test: true,
      pinpai_leimu_content: "",
      errodisplay_three: true,
      fuze_people: "请输入内容",
      colorerro_one: false,
      _conde_ma_key: "",
      colorerro_four: false,
      qiyeone_erro_two: "学校内容不能为空",
      yanzhengma_con: "",
      yanzheng_test_jigou: true,
      qiyeone_erro_three: "请选择国家",
      arrcitydatas_surplus: "",
      see_province_surplus: false,
      errodisplay_two: true,
      yanzheng_loding: true,
      chengshiview_surplus: "",
      colorerro_three: false,
      arrcitydatas: "",
      pinpai_leimu_data: [
        {
          value: "K12学科培训",
          label: "K12学科培训"
        },
        {
          value: "少儿英语培训",
          label: "少儿英语培训"
        },
        {
          value: "留学语言培训",
          label: "留学语言培训"
        },
        {
          value: "素质类教育培训",
          label: "素质类教育培训"
        },
        {
          value: "大学（高等教育）",
          label: "大学（高等教育）"
        },
        {
          value: "公立中小学校",
          label: "公立中小学校"
        },
        {
          value: "民办中小学校",
          label: "民办中小学校"
        },
        {
          value: "全日制国际学校",
          label: "全日制国际学校"
        },
        {
          value: "职业培训",
          label: "职业培训"
        },
        {
          value: "公益组织",
          label: "公益组织"
        },
        {
          value: "四六级与考研",
          label: "四六级与考研"
        },
        {
          value: "对外汉语",
          label: "对外汉语"
        },
        {
          value: "成人英语",
          label: "成人英语"
        },
        {
          value: "小语种",
          label: "小语种"
        },
        {
          value: "其他",
          label: "其他"
        }
      ],
      cities: Address.citiy,
      arrcitydata: Address.arrcity,
      value: "+86",
      input_content_jigou: "",
      numbererro: "手机号格式错误",
      input_yanzhengma: "",
      jigou_mingcheng_erro: "机构名称格式错误",
      city_view: "",
      jigou_show: "",
      jigou_show_check: "",
      chengshiview: "",
      colorerro_six: false
    };
  },
  methods: {
    country_change() {
      var couert_data = this.city_view;
      function findCherries(fruit) {
        return fruit.name === couert_data;
      }
      var this_arrshengfen_data = this.arrcitydata.find(findCherries);
      var test_shengfen = this_arrshengfen_data.hasOwnProperty("state");
      if (test_shengfen) {
        this.see_province = true;
        this.chengshiview = "";
        if (Array.isArray(this_arrshengfen_data.state)) {
          this.arrcitydatas = "";
          this.chengshiview = "";
          this.see_province_surplus = false;
          this.arrcitydatas = this_arrshengfen_data.state;
        } else if (this_arrshengfen_data.state instanceof Object) {
          this.arrcitydatas_surplus = "";
          this.see_province = false;
          this.chengshiview_surplus = "";
          this.see_province_surplus = true;
          this.arrcitydatas_surplus = this_arrshengfen_data.state.city;
        }
      } else {
        this.chengshiview = "";
        this.chengshiview_surplus = "";
        this.see_province = false;
        this.see_province_surplus = false;
      }
    },
    city_end() {
      var couert_end_data = this.chengshiview;
      function findCherries(fruit) {
        return fruit.name === couert_end_data;
      }
      this.arrcitydatas_surplus = "";
      this.chengshiview_surplus = "";
      var this_arrshengfen_data = this.arrcitydatas.find(findCherries);

      var test_city = this_arrshengfen_data.hasOwnProperty("city");
      if (test_city) {
        this.see_province_surplus = true;
        this.arrcitydatas_surplus = this_arrshengfen_data.city;
      } else {
        this.arrcitydatas_surplus = "";
        this.chengshiview_surplus = "";
        this.see_province_surplus = false;
      }
    },
    form_subit() {
      if (!this.checkeds) {
        this.zhucesub = true;
      } else {
        this.zhucesub = false;
      }
    },
    getCode() {
      var number_quhao = Number(this.value);
      let _this = this;
      var number_true = false;
      if (number_quhao === 86) {
        var repx1 = /^1[012345789]\d{9}$/g;
        if (this.input_content_jigou.length === 0) {
          this.errodisplay = false;
          this.colorerro = true;
          this.numbererro = "请输入手机号";
          number_true = false;
          return;
        }
        if (repx1.test(this.input_content_jigou)) {
          this.errodisplay = true;
          this.colorerro = false;
          number_true = true;
        } else {
          this.errodisplay = false;
          this.colorerro = true;
          this.numbererro = "手机号格式错误";
          number_true = false;
        }
      } else {
        var rexpx2 = /^[0-9]\d*$/g;
        if (this.input_content_jigou.length === 0) {
          this.errodisplay = false;
          this.colorerro = true;
          this.numbererro = "请输入手机号";
          number_true = false;
          return;
        }
        if (rexpx2.test(this.input_content_jigou)) {
          this.errodisplay = true;
          this.colorerro = false;
          number_true = true;
        } else {
          this.errodisplay = false;
          this.colorerro = true;
          this.numbererro = "手机号格式错误";
          number_true = false;
        }
      }
      if (number_true) {
        if (this.iscursor) {
          return;
        }
        this.iscursor = true;
        this.yanzheng_loding = false;
        let clock = setInterval(() => {
          this.time_loging--;
          if (this.time_loging < 0) {
            window.clearInterval(clock);
            this.time_loging = 60;
            this.iscursor = false;
            this.yanzheng_loding = true;
          }
        }, 1000);
        axios
          .post(
            "/n/api/sms/send",
            Qs.stringify({
              areaCode: number_quhao,
              phone: this.input_content_jigou
            })
          )
          .then(function(response) {
            if (response.data.code == 0) {
              _this._conde_ma_key = response.data.data.key;
              _this.yanzheng_test = true;
              _this.errodisplay_two_y = false;
            } else {
              _this.yanzheng_test = false;
              _this.yanzhengma_con = response.data.msg;
              _this.errodisplay_two_y = true;
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },
    sub_form_data: _.throttle(function() {
      let _this = this;
      if (this.checkeds) {
        var number_true = false;
        var _erweima = false;
        var _jigoushow = false;
        var _shengfen = false;
        var _city = false;
        var _email = false;
        var _guojia = false;
        var _password = false;
        var _enter = false;
        var _asspas = false;
        var _leimu = false;
        var _stundenname = false;
        var _principal = false;
        var number_quhao = Number(this.value);
        if (number_quhao === 86) {
          var repx1 = /^1[012345789]\d{9}$/g;
          if (this.input_content_jigou.length === 0) {
            this.errodisplay = false;
            this.colorerro = true;
            this.numbererro = "请输入手机号";
            return;
          }
          if (repx1.test(this.input_content_jigou)) {
            this.errodisplay = true;
            this.colorerro = false;
            number_true = true;
          } else {
            this.errodisplay = false;
            this.colorerro = true;
            this.numbererro = "手机号格式错误";
          }
        } else {
          var rexpx2 = /^[0-9]\d*$/g;
          if (this.input_content_jigou.length === 0) {
            this.errodisplay = false;
            this.colorerro = true;
            this.numbererro = "请输入手机号";
            return;
          }
          if (rexpx2.test(this.input_content_jigou)) {
            this.errodisplay = true;
            this.colorerro = false;
            number_true = true;
          } else {
            this.errodisplay = false;
            this.colorerro = true;
            this.numbererro = "手机号格式错误";
          }
        }
        if (number_true) {
          var rexp_3 = /^[0-9]{6}$/g;
          if (this.input_yanzhengma == "") {
            this.yanzheng_test = false;
            this.yanzhengma_con = "验证码必须是6位数字";
            this.yanzhengdisplays = true;
            this.errodisplay_two_y = true;
          } else if (rexp_3.test(this.input_yanzhengma)) {
            this.yanzheng_test = true;
            this.yanzhengdisplays = false;
            this.errodisplay_two_y = false;
            _erweima = true;
          } else {
            this.yanzheng_test = false;
            this.yanzhengma_con = "验证码必须是6位数字";
            this.yanzhengdisplays = true;
            this.errodisplay_two_y = true;
          }
        }
        if (number_true && _erweima) {
          if (this.jigou_show === "") {
            _jigoushow = true;
            this.yanzheng_test_jigou = true;
          } else {
            if (this.jigou_show.length > 30) {
              this.yanzheng_test_jigou = false;
              this.jigou_mingcheng_erro = "内容长度不超过30个字符";
            } else {
              this.yanzheng_test_jigou = true;
              _jigoushow = true;
            }
          }
        }
        if (number_true && _erweima && _jigoushow) {
          if (this.jigou_show_check === "") {
            this.colorerro_one = true;
            this.errodisplay_two = false;
            this.qiyeone_erro_two = "请输入内容";
          } else {
            if (this.jigou_show_check.length > 30) {
              this.colorerro_one = true;
              this.errodisplay_two = false;
              this.qiyeone_erro_two = "内容长度不超过30个字符";
            } else {
              this.colorerro_one = false;
              this.errodisplay_two = true;
              _stundenname = true;
            }
          }
        }
        if (number_true && _erweima && _jigoushow && _stundenname) {
          if (this.city_view == "") {
            this.colorerro_three = true;
          } else {
            this.colorerro_three = false;
            _guojia = true;
          }
        }
        if (number_true && _erweima && _jigoushow && _stundenname && _guojia) {
          if (this.chengshiview == "") {
            if (this.see_province === false) {
              _shengfen = true;
            } else {
              this.colorerro_four = true;
            }
          } else {
            this.colorerro_four = false;
            _shengfen = true;
          }
        }
        if (
          number_true &&
          _erweima &&
          _jigoushow &&
          _stundenname &&
          _guojia &&
          _shengfen
        ) {
          if (this.chengshiview_surplus == "") {
            if (this.see_province_surplus === false) {
              this.colorerro_six = false;
              _city = true;
            } else {
              this.colorerro_six = true;
            }
          } else {
            this.colorerro_six = false;
            _city = true;
          }
        }
        if (
          number_true &&
          _erweima &&
          _jigoushow &&
          _stundenname &&
          _guojia &&
          _shengfen &&
          _city
        ) {
          if (this.pinpai_leimu_content == "") {
            this.colorerro_seven = true;
          } else {
            this.colorerro_seven = false;
            _leimu = true;
          }
        }
        if (
          number_true &&
          _erweima &&
          _jigoushow &&
          _stundenname &&
          _guojia &&
          _shengfen &&
          _city &&
          _leimu
        ) {
          _principal = true;
        }
        if (
          number_true &&
          _erweima &&
          _jigoushow &&
          _stundenname &&
          _guojia &&
          _shengfen &&
          _city &&
          _leimu &&
          _principal
        ) {
          _email = true;
        }
        if (
          number_true &&
          _erweima &&
          _jigoushow &&
          _stundenname &&
          _guojia &&
          _shengfen &&
          _city &&
          _leimu &&
          _principal &&
          _email
        ) {
          _password = true;
        }
        if (
          number_true &&
          _erweima &&
          _jigoushow &&
          _stundenname &&
          _guojia &&
          _shengfen &&
          _city &&
          _leimu &&
          _principal &&
          _email &&
          _password
        ) {
          var rexp_passwordl = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)([^\s]){8,16}$/;
          if (rexp_passwordl.test(this.pinpai_name_password)) {
            this.affirm_password = this.pinpai_name_password;
            this.colorerro_one_pass = false;
            this.colorerro_pass_erro = true;
            _asspas = true;
          } else {
            this.colorerro_one_pass = true;
            this.colorerro_pass_erro = false;
          }
        }
        if (
          number_true &&
          _erweima &&
          _jigoushow &&
          _stundenname &&
          _guojia &&
          _shengfen &&
          _city &&
          _leimu &&
          _principal &&
          _email &&
          _password &&
          _asspas
        ) {
          if (this.pinpai_name_password_affirm == this.affirm_password) {
            this.colorerro_one_affar = false;
            this.colorerro_erro_affar = true;
            _enter = true;
          } else {
            this.colorerro_one_affar = true;
            this.colorerro_erro_affar = false;
          }
        }
        if (
          number_true &&
          _erweima &&
          _jigoushow &&
          _stundenname &&
          _guojia &&
          _shengfen &&
          _city &&
          _leimu &&
          _principal &&
          _email &&
          _password &&
          _asspas &&
          _enter
        ) {
          if (!this._conde_ma_key) {
            this.yanzheng_test = false;
            this.yanzhengma_con = "验证码错误";
            this.errodisplay_two_y = true;
          } else {
            this.yanzheng_test = true;
            this.errodisplay_two_y = false;
            var new_chargePersonPhon =
              number_quhao + " " + _this.input_content_jigou;
            axios
              .post(
                "/s/api/school/phone/register" /*最新代码位置*/,
                Qs.stringify({
                  areaCode: number_quhao,
                  brandName: _this.jigou_show,
                  chargePersonPhone: new_chargePersonPhon,
                  city: _this.chengshiview_surplus,
                  code: _this.input_yanzhengma,
                  country: _this.city_view,
                  key: _this._conde_ma_key,
                  mainCategories: _this.pinpai_leimu_content,
                  password: _this.pinpai_name_password,
                  password2: _this.pinpai_name_password_affirm,
                  phone: _this.input_content_jigou,
                  province: _this.chengshiview,
                  schoolName: _this.jigou_show_check
                })
              )
              .then(function(response) {
                if (response.data.code == 0) {
                  _this.$message({
                    showClose: true,
                    message: "恭喜你,注册成功",
                    duration: 3000,
                    type: "success",
                    onClose: () => {
                      window.scrollTo(0, 0);
                      _this.$router.push("/password-login");
                    }
                  });
                } else {
                  _this.$message({
                    showClose: true,
                    message: response.data.msg,
                    type: "error"
                  });
                }
              })
              .catch(function(error) {});
          }
        }
      } else {
        return;
      }
    }, 2000)
  }
};
</script>

<style scoped lang="less">
#login_wrap_denglu {
  width: 100%;
  height: 155px;
  overflow: hidden;
  background-color: #eee;
  text-align: center;
  .login_wrap_denglu_top {
    font-family: " MicrosoftYaHei";
    font-size: 30px;
    color: #222743;
    margin-top: 45px;
    line-height: 52px;
    letter-spacing: 1px;
  }
  .yanzhengma_enter {
    color: #066fff;
    font-family: " MicrosoftYaHei";
    margin-top: 10px;
    display: inline-block;
  }
}

#jigou_form {
  width: 100%;
  padding-bottom: 80px;
  .jigou_form_wrap {
    width: 360px;
    height: auto;
    margin: 0 auto;
    margin-top: 36px;
    // border: 1px solid red;
    .jigou_form_wrap_tip {
      font-family: "MicrosoftYaHei";
      font-size: 12px;
      color: #999999;
      margin-left: 50px;
    }
  }
  .colorerro_ele {
    visibility: hidden;
  }
  .colordisplays {
    visibility: hidden;
  }
  .colorerro_erro_affar {
    visibility: hidden;
  }
  .colorerro_nine {
    visibility: hidden;
  }
  .colorerro_email_erro {
    visibility: hidden;
  }
  .colorerro_pass_erro {
    visibility: hidden;
  }
  .qiyeone_erros {
    .number_erro_content {
      font-size: 12px;
      color: #f56c6c;
      font-family: "MicrosoftYaHei";
      margin-left: 0px;
    }
  }
  .colordisplays_two {
    visibility: hidden;
  }
  .colordisplays_three {
    visibility: hidden;
  }
  .qiyeone_erro {
    margin-top: 3px;
    .number_erro_content {
      font-size: 12px;
      color: #f56c6c;
      font-family: "MicrosoftYaHei";
      margin-left: 50px;
    }
  }
  .yanzheng_jigou {
    visibility: hidden;
  }
  .yanzheng_loding {
    visibility: hidden;
  }
  .yanzheng_test {
    visibility: hidden;
  }

  .iscursor {
    cursor: no-drop;
  }
  .jigou_form_form_number {
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    margin-top: 10px;
    .jigou_form_form_number_left {
      margin-left: 50px;
      .jigou_wrap_form_number_left_se {
        width: 80px;
        height: 30px;
      }
    }
  }
  .jigou_for_number_right {
    margin-right: 50px;
    width: 170px;
  }
  .number_erro {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin-top: 3px;
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    justify-content: flex-end;
    .number_erro_content {
      margin-right: 50px;
      width: 170px;
      font-size: 12px;
      color: #f56c6c;
      font-family: "MicrosoftYaHei";
    }
  }
  .yanzheng_code {
    font-family: "MicrosoftYaHei";
    font-size: 12px;
    color: #999999;
    margin-top: 3px;
    margin-left: 50px;
  }
  .yanzhengma_bor {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    margin-top: 10px;
    .yanzhengma_bor_left_infor {
      margin-left: 50px;
      width: 170px;
      height: 30px;
    }
    .yanzhengma_bor_btn {
      margin-right: 50px;
    }
    .impro_btn {
      width: 87px;
      line-height: 30px;
      display: block;
      padding: 0px;
      text-align: center;
      font-size: 12px;
      color: #3366ff;
      border-color: #cccccc;
    }
  }
  .yanzhengma_erro {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    margin-top: 3px;
    .yanzheng_cuowu {
      font-size: 12px;
      color: #f56c6c;
      font-family: "MicrosoftYaHei";
      margin-left: 50px;
    }
    .yanzheng_time_lodaing {
      font-size: 12px;
      color: #909399;
      font-family: "MicrosoftYaHei";
      margin-right: 50px;
    }
  }
  .pinpai_content {
    font-family: "MicrosoftYaHei";
    font-size: 12px;
    color: #999999;
    margin-top: 20px;
    margin-left: 50px;
  }
  .jigou_mingcheng_text {
    width: 260px;
    margin-left: 50px;
    margin-top: 10px;
  }
  .jigou_mingcheng_erro {
    margin-top: 3px;
    .jigou_mingcheng_erro_text {
      font-size: 12px;
      color: #f56c6c;
      font-family: "MicrosoftYaHei";
      margin-left: 50px;
    }
  }
  .pinpai_content_gongsi {
    font-family: "MicrosoftYaHei";
    font-size: 12px;
    color: #999999;
    margin-top: 20px;
    margin-left: 50px;
  }
  .jigou_mingcheng_text_checked {
    width: 260px;
    margin-left: 50px;
    margin-top: 10px;
  }
  .pinpai_content_adress {
    font-family: "MicrosoftYaHei";
    font-size: 12px;
    color: #999999;
    margin-top: 20px;
    margin-left: 50px;
  }
  .pinpai_content_adress_content {
    width: 260px;
    margin-left: 50px;
    margin-top: 10px;
  }
  .country_select {
    width: auto;
    margin-bottom: 8px;
  }
  .pinpai_leimu {
    font-family: "MicrosoftYaHei";
    font-size: 12px;
    color: #999999;
    margin-top: 20px;
    margin-left: 50px;
  }
  .pinpai_leimu_content {
    width: 260px;
    margin-left: 50px;
    margin-top: 10px;
  }
  .pinpai_name {
    font-family: "MicrosoftYaHei";
    font-size: 12px;
    color: #999999;
    margin-top: 20px;
    margin-left: 50px;
  }
  .pinpai_name_input {
    width: 260px;
    margin-left: 50px;
    margin-top: 10px;
  }
  .pinpai_number {
    font-family: "MicrosoftYaHei";
    font-size: 12px;
    color: #999999;
    margin-top: 20px;
    margin-left: 50px;
  }
  .pinpai_name_input_number {
    width: 260px;
    margin-left: 50px;
    margin-top: 10px;
  }
  .pinpai_email {
    font-family: "MicrosoftYaHei";
    font-size: 12px;
    color: #999999;
    margin-top: 20px;
    margin-left: 50px;
  }
  .pinpai_name_input_emali {
    width: 260px;
    margin-left: 50px;
    margin-top: 10px;
  }
  .pinpai_name_password {
    font-family: "MicrosoftYaHei";
    font-size: 12px;
    color: #999999;
    margin-top: 20px;
    margin-left: 50px;
  }
  .pinpai_name_input_passwordl {
    width: 260px;
    margin-left: 50px;
    margin-top: 10px;
  }
  .zhuce_wrap_form_submit {
    margin-left: 50px;
    margin-top: 10px;
    .zhuce_wrap_form_submit_btn {
      width: 260px;
      line-height: 30px;
      text-align: center;
      background-color: #dcdcdc;
      font-size: 14px;
      color: #000000;
      cursor: pointer;
      border: none;
      padding: 0;
      font-family: "MicrosoftYaHei";
      font-size: 12px;
    }
    .zhuce_sub {
      background-color: #3366ff;
      color: #ffffff;
    }
  }
  .agree_tiaoyue {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    margin-top: 20px;
    .agree_tiaoyue_btn {
      margin-left: 50px;
    }
  }
  .agree_tiaoyue_text {
    line-height: 16px;
    font-size: 12px;
    margin-right: 50px;
    margin-left: 10px;
  }
}
</style>
<style lang="less">
#jigou_form {
  .el-input--suffix .el-input__inner {
    height: 30px;
    padding: 0;
    padding-left: 11px;
    display: block;
    margin-right: 11px;
  }
  .el-input__icon {
    line-height: 30px; //左下角箭头对齐关键代码
  }
  .colorerro .el-input__inner {
    border-color: #f56c6c;
  }
  .el-input__inner {
    padding: 0;
    margin: 0;
    width: 100%;
    padding-left: 11px;
    border-radius: 3px;
    height: 30px;
  }
  .colorerro_one .el-input__inner {
    border-color: #f56c6c;
  }
  .colordisplays_two_y {
    .el-input__inner {
      border-color: #f56c6c;
    }
  }
  .colorerro_four {
    .el-input__inner {
      border-color: #f56c6c;
    }
  }
  .colorerro_three {
    .el-input__inner {
      border-color: #f56c6c;
    }
  }
  .colorerro_six {
    .el-input__inner {
      border-color: #f56c6c;
    }
  }
  .colorerro_seven {
    .el-input__inner {
      border-color: #f56c6c;
    }
  }
  .colorerro_email {
    .el-input__inner {
      border-color: #f56c6c;
    }
  }
  .colorerro_one_pass {
    .el-input__inner {
      border-color: #f56c6c;
    }
  }
  .colorerro_eight {
    .el-input__inner {
      border-color: #f56c6c;
    }
  }
  .colorerro_one_affar {
    .el-input__inner {
      border-color: #f56c6c;
    }
  }
  .colorerro_ten {
    .el-input__inner {
      border-color: #f56c6c;
    }
  }
  .yanzhengma_bor_btn {
    .el-button:focus,
    .el-button:hover {
      color: #3366ff;
      border-color: #ccc;
      background-color: none;
      background-color: #ffffff;
    }
  }
  .country_select {
    .el-input__inner {
      height: 24px;
    }
    .el-input__icon {
      line-height: 24px; //左下角箭头对齐关键代码
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/jigou.vue